import { createSelector, createSlice } from "@reduxjs/toolkit";
import { generateClient } from 'aws-amplify/api';
import { getScope, listScopes, scopesByLocationId, searchScopes } from "../graphql/queries";
import { reset } from "./globalActions";
import { updateScope } from "../graphql/mutations";

const client = generateClient();

const moduleName = "scopeOfWork";

const initialState = {
    loading: false,
    items: [],
    nextToken: null,
};

const scopeOfWorkSlice = createSlice({
    name: moduleName,
    initialState,
    extraReducers: (builder) => {
        builder.addCase(reset, () => initialState);
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setItems: (state, action) => {
            state.items = action.payload;
        },
        updateItem: (state, action) => {
            const idx = state.items.findIndex(i => i.id === action.payload.id);
            if (idx < 0) { state.items.push(action.payload) }
            else { state.items[idx] = action.payload }
        }
    },
});

export const { setLoading, setItems, updateItem } = scopeOfWorkSlice.actions;
export default scopeOfWorkSlice.reducer;

export const selectState = (state) => state[moduleName];
export const selectLoading = createSelector(selectState, (state) => state.loading);
export const selectScopeOfWorks = createSelector(selectState, (state) => state.items);
export const selectScopeOfWorkById = createSelector(
    selectScopeOfWorks,
    (state, id) => id,
    (scopeOfWorks, id) => scopeOfWorks.find((c) => c.id === id)
);

export const fetchScopeOfWorks = (locationId) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const { data } = await client.graphql({
            query: scopesByLocationId,
            variables: {
                locationId,
                filter: {
                    active: { eq: true },
                    or: [
                        { account: { eq: "COS - Labour" } },
                        { account: { eq: "COS - Shop Labour" } },
                        { account: { eq: "Training & Safety Expense" } },
                    ]
                },
                limit: 1000  //Need this otherwise all items don't appear in the list.
            },
        });
        dispatch(setItems(data.scopesByLocationId.items));
        return data.scopesByLocationId.items;
    } catch (ex) {
        console.log("failed to get scopes", ex);
    } finally {
        dispatch(setLoading(false));
    }
};

export const fetchScopeOfWork = (id, locationId) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const { data } = await client.graphql({
            query: getScope,
            variables: {
                id,
                locationId,
            },
        });
        dispatch(updateItem(data.getScope));
        return data.getScope;
    } catch (ex) {
        console.log("failed to get scope", ex);
    } finally {
        dispatch(setLoading(false));
    }
};

export const findScopeOfWorks = (search) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const { data } = await client.graphql({
            query: searchScopes,
            variables: {
                filter: {
                    name: {
                        wildcard: `*${search}*`,
                    },
                },
                sort: { direction: "asc", field: "name" },
                limit: 50,
            },
        });
        dispatch(setItems(data.searchScopes.items));
        return data.searchScopes.items;
    } catch (ex) {
        console.log("failed to get scopeOfWorks", ex);
    } finally {
        dispatch(setLoading(false));
    }
};

export const modifyScopeOfWork = ({ id, locationId, name, fullName }) => async (dispatch) => {
    const { data } = await client.graphql({
        query: updateScope,
        variables: {
            input: {
                id,
                locationId,
                fullName,
                name,
            }
        }
    });
    dispatch(updateItem(data.updateScope))
    return data.updateScope;
}
